import Zoomer from "../../../../stock_locator/views/detail/zoomer/zoomer";
import Rental from "../../../../rental/rental";

const VehicleDetail = {

    init() {
        this.el = $('[page].Vehicle');

        if (!this.el.length) {
            return;
        }

        this.slider = this.el.find('[block="slider"] .slider');
        this.zoomInBtn = this.el.find('.button.zoom');
        this.nextButton = this.el.find('.actions .button.next');
        this.thumbs = this.el.find('.thumbs .image');

        this.start();
        this.bind();
    },

    start() {
        this.slider.addClass('owl-carousel');
        this.slider.owlCarousel({
            "smartSpeed": 750,
            "loop": true,
            "autoWidth": false,
            "nav": true,
            "dots": true,
            "progress": true,
            "counter": false,
            "margin": 20,
            "stagePadding": 0,
            "items": 1,
            "navText": ["", ""]
        });

        Zoomer.init(this.el);
    },

    bind() {
        this.nextButton.click((evt) => {
            const id = $(evt.currentTarget).closest('section').attr('id');
            this.setVehicle(id);
        })

        this.thumbs.click((evt)=>{
            const nmb = $(evt.currentTarget).attr('order');
            Zoomer.create(nmb);
        })
    },

    setVehicle(id){
        if(rentalHash) Rental.load(null, {vehicle: id});
        window.location.href = '/' + window.T.rental.routes.reservation + '?vehicle=' + id;
    },
}

export default VehicleDetail;